module.exports = __webpack_public_path__ + "static/media/3empty.6909677c.png";